import { milestones } from '../../../mocks/ueber-uns';

export default function FirmengeschichteTimeline() {
  return (
    <section id="firmengeschichte" className="py-20 sm:py-24 bg-[#e9e4dc]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14 sm:mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest text-[#0D2B4E]/75 uppercase mb-3">
            Wie alles begann
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0D2B4E] mb-4">Unsere Gründungsgeschichte</h2>
          <p className="text-gray-600 text-base sm:text-lg leading-relaxed">
            2021 gegründet — aber mit deutlich mehr als vier Jahren Erfahrung im Gepäck.
            Hier ist die Geschichte von Menschen, die den Mut hatten, ihr Wissen in die eigene Unternehmung
            zu investieren.
          </p>
        </div>

        <div className="relative">
          {/* Center line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-[#0D2B4E]/25 -translate-x-1/2" />

          <div className="space-y-8 sm:space-y-10">
            {milestones.map((item, index) => (
              <div
                key={item.year}
                className={`relative flex flex-col lg:flex-row items-start lg:items-center gap-6 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Content card */}
                <div className="w-full lg:w-5/12">
                  <div className="bg-white rounded-xl p-6 sm:p-7 border border-gray-150 hover:border-[#0D2B4E]/25 transition-colors">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-9 h-9 flex items-center justify-center bg-[#0D2B4E]/10 rounded-lg">
                        <i className={`${item.icon} text-[#0D2B4E] text-lg`} />
                      </div>
                      <span className="text-xs font-bold tracking-widest text-[#0D2B4E]/65 uppercase">{item.year}</span>
                    </div>
                    <h3 className="text-lg font-bold text-[#0D2B4E] mb-2">{item.title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">{item.description}</p>
                  </div>
                </div>

                {/* Center dot */}
                <div className="hidden lg:flex w-2/12 justify-center flex-shrink-0">
                  <div className="w-5 h-5 rounded-full bg-[#0D2B4E] border-4 border-white ring-2 ring-[#0D2B4E]/40 z-10" />
                </div>

                {/* Year tag on opposite side */}
                <div className="hidden lg:flex w-5/12 items-center">
                  <div
                    className={`flex items-center gap-2 ${
                      index % 2 === 0 ? 'justify-start' : 'justify-end w-full'
                    }`}
                  >
                    <span className="text-4xl font-black text-[#0D2B4E]/12 select-none">{item.year}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
